import { HashRouter as Router, Routes, Route } from "react-router-dom";
import { AppProvider } from "./AppContext";
import './App1.css'
import Sidebar from "./components/Sidebar";
import Project from "./pages/Project";
import About from "./pages/About";
import Member from "./pages/Member";
import Shop from "./pages/Shop";
import Join from "./pages/Join";
import Design from "./pages/Design";
import Detail from "./pages/Detail";
import Pdf from "./pages/pdf";
import Video from "./pages/Video";
import './App.css'
import './AppMb.css'
function App() {
  return (
    <AppProvider>
      <Router>
        <div className="app-layout" id="app">
          <Sidebar />
          <div className="content">
            <Routes>
              <Route path="/*" element={<Project />} />
              <Route path="/:projectId" element={<Project />} />

              <Route path="/about" element={<About />} />
              <Route path="/member" element={<Member />} />
              <Route path="/shop" element={<Shop />} />
              <Route path="/join" element={<Join />} />
              <Route path="/design" element={<Design />} />
              <Route path="/detail" element={<Detail />} />
              <Route path="/design/:projectId" element={<Pdf />} />
              <Route path="/video" element={<Video />} />

              

            </Routes>
          </div>
          <section data-v-29e4ff3a="" id="footer" class="mainGray">
            <div data-v-29e4ff3a="">
              <p data-v-29e4ff3a="">
                <small data-v-29e4ff3a=""> Copyright © 2025 anpulei.cn All Rights Reserved  <a data-v-29e4ff3a="" href="http://www.beian.miit.gov.cn" target="_blank">辽ICP备2025051634号</a></small>
              </p>
            </div>
          </section>

          
        </div>
      </Router>
    </AppProvider>
  );
}

export default App;